import { apiClient } from './client';
import type { AuditEntry } from '@/types/oscar';

export interface AuditQuery {
  entityType?: string;
  entityId?: string | number;
  feature?: string;
  take?: number;
}

/** GET /api/audit — recent audit rows for an entity / feature (any role). */
export function getAudit(query: AuditQuery, signal?: AbortSignal): Promise<AuditEntry[]> {
  const params = new URLSearchParams();
  if (query.entityType) params.set('entityType', query.entityType);
  if (query.entityId !== undefined) params.set('entityId', String(query.entityId));
  if (query.feature) params.set('feature', query.feature);
  if (query.take) params.set('take', String(query.take));
  const qs = params.toString();
  return apiClient.get<AuditEntry[]>(`/api/audit${qs ? `?${qs}` : ''}`, signal);
}
